import angular from 'angular';

angular.module('cloudX').directive('cxToggleCollapsed', [
  '$parse',
  'userData',
  function($parse, userData) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var onToggle = $parse(attrs.onToggle) || angular.noop;
        var onInit = $parse(attrs.onInit) || angular.noop;

        var fn = $parse(attrs.cxToggleCollapsed);
        var saveValue = function(data) {
          var key = attrs.collapsedKey;
          if (!key) return;
          //console.log('saving ' + key + ': ' + data);
          userData.update('collapsed', function(value) {
            if (!value) value = {};
            value[key] = !!data;
            return value;
          });
        };

        element.on('click', function() {
          scope.$apply(function() {
            var value = fn(scope);
            fn.assign(scope, !value);
            onToggle(scope, {
              $collapsed: !value,
            });
            //saveValue(!value);
          });
        });

        var defaultValue = attrs.defaultCollapsed === 'true';

        var value = fn(scope);
        var key = attrs.collapsedKey;
        if (!!key) {
          value = userData.get('collapsed', {})[key];
          scope.$watch(attrs.cxToggleCollapsed, function(newValue, oldValue) {
            if (newValue !== oldValue) saveValue(newValue);
          });
        }
        if (typeof value === 'undefined' || value === null) {
          value = defaultValue;
          saveValue(value);
        }
        fn.assign(scope, value);
        onInit(scope, {
          $collapsed: value,
        });
      },
    };
  },
]);
